import { render, staticRenderFns } from "./decContainerTable.vue?vue&type=template&id=aa8d790c&scoped=true"
import script from "./decContainerTable.vue?vue&type=script&lang=js"
export * from "./decContainerTable.vue?vue&type=script&lang=js"
import style0 from "./decContainerTable.vue?vue&type=style&index=0&id=aa8d790c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8d790c",
  null
  
)

export default component.exports